export default __webpack_public_path__ + "static/media/IconPdf.60ce916f.svg";